class OpalWoocommerceSingleProduct {
    constructor() {
        var self = this;
        
        this.initSlideProduct();

        $('.woocommerce-product-gallery').on('wc-product-gallery-after-init', function () {
            if ($('body').hasClass('woocommerce-single-style-4')) {
                self.productVerticalSlider();
            }
            if ($('body').hasClass('woocommerce-single-style-1')) {
                self.productHorizontalSlider();
            }
        });

        if ($('body').hasClass('woocommerce-single-style-4')) {
            $( '.woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image:eq(0) .wp-post-image' ).one( 'load', function() {
                var $image = $( this );
                if ( $image ) {
                    setTimeout( function() {
                        var $slider_height = $image.closest( '.woocommerce-product-gallery__image' ).height();
                        var $slider = $('.woocommerce-single-style-4 .woocommerce-product-gallery .flex-control-thumbs');
                        $slider.css({
                            'height': $slider_height,
                            'overflow': 'hidden'
                        });

                        $('.woocommerce-product-gallery').on('wc-product-gallery-after-init', function () {
                            self.productVerticalSlider();
                        });
                    }, 100 );
                }
            } )
        }
    }

    initSlideProduct() {
        let lightbox = $('.single-product .woocommerce-product-gallery__image > a');
        if (lightbox.length) {
            lightbox.attr("data-elementor-open-lightbox", "no");
        }
    }

    productVerticalSlider() {
        var rtl = $('body').hasClass('rtl');
        
        var $slider = $('.woocommerce-single-style-4 .woocommerce-product-gallery .flex-control-thumbs');
        let $slider_height = $('.woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image').height();
        
        let child_height = 0,
            slidesToShow = 5;
        let has_slider = false;

        $('.woocommerce-product-gallery .flex-control-thumbs li').each(function (i, e) {
            child_height += 90;
            if (child_height > $slider_height) {
                slidesToShow = i;
                has_slider = true;
                return false;
            }
        });

        $slider.not('.slick-initialized').slick({
            rtl: rtl,
            infinite: false,
            slidesToShow: slidesToShow,
            vertical: true,
            verticalSwiping: true,
            prevArrow:"<button type='button' aria-label='Previous' class='slick-prev slick-arrow'><i class='fa fa-angle-up' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' aria-label='Next' class='slick-next slick-arrow'><i class='fa fa-angle-down' aria-hidden='true'></i></button>"
        });

        if (has_slider) {
            $slider.slick('slickSetOption', 'slidesToShow', slidesToShow);
        }else {
            $slider.slick('unslick');
        }

    }
    
    productHorizontalSlider() {
        console.log('tesst');
        var rtl = $('body').hasClass('rtl');
        
        var $slider = $('.woocommerce-single-style-1 .woocommerce-product-gallery .flex-control-thumbs');
        let $slider_width = $('.woocommerce-single-style-1 .woocommerce-product-gallery .flex-viewport').width();
        $slider.css({
            'width': $slider_width,
            'overflow': 'hidden'
        });
        let child_width = 0,
            slidesToShow = 5;
        let has_slider = false;

        $('.woocommerce-product-gallery .flex-control-thumbs li').each(function (i, e) {
            child_width += 90;
            if (child_width > $slider_width) {
                slidesToShow = i;
                has_slider = true;
                return false;
            }
        });

        $slider.not('.slick-initialized').slick({
            rtl: rtl,
            infinite: false,
            slidesToShow: slidesToShow,
            vertical: false,
            verticalSwiping: false,
            prevArrow:"<button type='button' aria-label='Previous' class='slick-prev slick-arrow'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
            nextArrow:"<button type='button' aria-label='Next' class='slick-next slick-arrow'><i class='fa fa-angle-right' aria-hidden='true'></i></button>"
        });

        if (has_slider) {
            $slider.slick('slickSetOption', 'slidesToShow', slidesToShow);
        }else {
            $slider.slick('unslick');
        }

    }
}

new OpalWoocommerceSingleProduct();